<template>
    <div class="dx-content" :class="{ 'collapsed': sidebarHidden }">
    <dx-heading size="xl" class="title">{{ title }}</dx-heading>
    <div class="content"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'dx-content',

  props: {
    sidebarHidden: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
};
</script>

<style scoped lang="scss">
  .dx-content {
    height: calc(100vh - var(--dx-topbar--height));
    padding: var(--dx-space-size--xs) var(--dx-space-size--sm);
    overflow: auto;

    max-width: calc(100vw - var(--dx-navbar--aside-width));
    margin-left: var(--dx-navbar--aside-width);
    transition: margin-left 0.3s ease;

    .title {
      margin: var(--dx-space-size--xs) 2px 0;
    }

    .content {
      padding: var(--dx-space-size--sm) var(--dx-space-size--xs);
      margin-top: 4px;
      border-radius: 4px;

    }
  }

  .collapsed {
    max-width: calc(100vw - var(--dx-navbar--aside-hidden-width));
    margin-left: var(--dx-navbar--aside-hidden-width);
  }
</style>
